export function shopReducer(state = "",{
    type,
    payload
}){
    switch(type){
        case "NEW_SHOP":
        case "UPDATE_SHOP":
            return {
                ...state,
                [payload.id]: payload
            }
        case "GET_SHOPS":
            return payload;
        case "SET_LOGO":
            return {
                ...state,
                [payload.shopID]: {
                    ...state[payload.shopID],
                    src: payload.logoSRC
                }
            }
        default:
            return state;
    }
}